import { createAction } from '@reduxjs/toolkit';

import type { WithdrawTypes } from '@modules';
import api from '@modules/api';
import { createAsyncActions, createActions } from '@modules/helpers';

import { SetAddressType, AddressType } from './types';

const actions = createActions('withdraw', {
  setAddress: name => createAction<SetAddressType>(name),

  setAddressValidation: name => createAction<AddressType>(name),

  setAddressLoading: name => createAction<boolean>(name),

  setFeeId: name => createAction<string | undefined>(name),

  clearErrors: name => createAction<void>(name),

  clearAddressData: name => createAction<void>(name),
});

export const asyncActions = createAsyncActions('withdraw', {
  withdraw: (data: WithdrawTypes.POSTWithdrawParams, thunkApi) =>
    api.post<WithdrawTypes.POSTWithdrawResponse>(thunkApi, '/withdraw', data),

  validateAddress: (params: WithdrawTypes.ValidateAddressParams, thunkApi) =>
    api.get<WithdrawTypes.ValidateAddressResponse>(thunkApi, '/validate/address', { params }),

  withdrawVerifyEmail: (data: WithdrawTypes.POSTWithdrawVerifyEmailParams, thunkApi) =>
    api.post<WithdrawTypes.POSTWithdrawVerifyEmailResponse>(
      thunkApi,
      '/withdraw/verify-email',
      data
    ),

  getWithdrawRate: (data: WithdrawTypes.GETWithdrawRateParams, thunkApi) =>
    api.get<WithdrawTypes.GETWithdrawRateResponse>(thunkApi, '/withdraw/rate', { params: data }),

  getWithdrawEstimate: (data: WithdrawTypes.GETWithdrawEstimateFeeParams, thunkApi) => {
    const url = '/withdraw/estimate-fee';
    return api.get<WithdrawTypes.GETWithdrawEstimateFeeResponse>(thunkApi, url, { params: data });
  },

  withdrawResendVerification: (data: WithdrawTypes.ResendVerificationParams, thunkApi) => {
    const url = '/withdraw/resend';
    return api.post<WithdrawTypes.ResendVerificationResponse>(thunkApi, url, data);
  },
  withdrawVerifyOTP: (data: WithdrawTypes.WithdrawOTPVerify, thunkApi) => {
    const url = '/withdraw/verify-otp';
    return api.post<void>(thunkApi, url, data);
  },
});

export default { ...actions, ...asyncActions };
